export const defaultCommunityTag = {
  category: 'Community',
  tagName: 'communityName',
  tagValue: null
};

export const allSurveysVisibleOptions = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
];

export const communityTypeOptions = [
  {
    value: 'WEB_PANEL',
    label: 'Web panel (do not ask respondents to download mobile app)'
  },
  {
    value: 'MOBILE_APP',
    label: 'Mobile app (ask respondents to download mobile app)'
  }
];

export const seeGiveawayMessageOptions = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
];
